var map = {
	"./aleo.png": "8805",
	"./bg.png": "a99f",
	"./btc.png": "9107",
	"./declaration.png": "f7bb",
	"./etc.png": "0fa2",
	"./eth.png": "8485",
	"./filecoin.png": "4a9a",
	"./icon1.png": "56a3",
	"./icon2.png": "cc3f",
	"./icon21.png": "d5c4",
	"./icon222.png": "793c",
	"./img0.png": "1894",
	"./img1.png": "a216",
	"./img2.png": "96a0",
	"./notice.png": "146b",
	"./notice_read.png": "bf55",
	"./power.png": "0350",
	"./qubic.png": "b2fb",
	"./server.png": "b42e8",
	"./smh.png": "fc5e",
	"./tao.png": "66eb",
	"./usdt.png": "d3b1",
	"./w1.png": "d5d6",
	"./w2.png": "15d1",
	"./w3.png": "b5f5",
	"./w4.png": "5322",
	"./wallet.png": "3101"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e70";